import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
    position: relative;
    width: 100%;
    padding: 10em 0 5em 0;
    &.closed {
        filter: grayscale(1);
        opacity: .5;
        padding: 0em 0 5em 0;
    }
    .layout-container {
        background-color: #FFFFFF;
    }
    .header-cont {
        display: flex;
        justify-content: space-between;
        padding: 0 2em;
    }

    .public-page-job-section-job-blocks-job-header-mobile {
        display: none;
    }
    @media all and (max-width: ${vars.mobileL}) {
        padding: 7em 0;
        &.closed {
            padding-bottom: 0;
        }
        .content-container {
            max-width: 100%;
            width: 100%;
        }

        .public-page-job-section-job-blocks-job-header {
            display: none;
        }

        .public-page-job-section-job-blocks-job-header-mobile {
            display: flex;
            padding: 1.4em 0.5em;
            padding-left: 3em;
        }
    }
`;